import { useMemo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { CurecallSelect, CurecallSelectItem } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import { EHumanReviewRequestSubject } from 'src/pages/dashboard/_components/human-review-requests.type'
import { TChatbotGeneralFormValues } from '../chatbot-form.type'

export function ChatbotDashboardTabField() {
  const { t } = useTranslation()
  const {
    control,
    setValue,
    getValues,
    clearErrors,
    formState: { errors },
  } = useFormContext<TChatbotGeneralFormValues>()

  const tabOptions: CurecallSelectItem<EHumanReviewRequestSubject>[] = useMemo(
    () => [
      {
        label: t('pages.dashboard.human-review-requests.tabs.convocation'),
        value: EHumanReviewRequestSubject.CONVOCATION,
      },
      {
        label: t('pages.dashboard.human-review-requests.tabs.post-op-control'),
        value: EHumanReviewRequestSubject.POST_OP_CONTROL,
      },
      {
        label: t('pages.dashboard.human-review-requests.tabs.administrative-documents'),
        value: EHumanReviewRequestSubject.ADMINISTRATIVE_DOCUMENTS,
      },
      {
        label: t('pages.dashboard.human-review-requests.tabs.medical-documents'),
        value: EHumanReviewRequestSubject.MEDICAL_DOCUMENTS,
      },
    ],
    [t],
  )

  return (
    <Controller
      control={control}
      name="options.requestHumanReview.subject"
      rules={{
        validate: (value) => {
          const incompleteDelay = getValues('options.requestHumanReview.incompleteQuestionnaireDelay')
          const smsDelay = getValues('options.requestHumanReview.unreceivedSmsDelay')
          if (!value && (incompleteDelay || smsDelay)) return false
          return true
        },
      }}
      render={({ field }) => (
        <div className="c-flex c-flex-col c-gap-1">
          <CurecallSelect
            label={t('pages.configuration.followups.chatbot.general-form.dashboard-tab-label')}
            items={tabOptions}
            onChange={(option) => {
              setValue('options.requestHumanReview.subject', option.value, { shouldDirty: true })
              clearErrors('options.requestHumanReview.subject')
            }}
            selectedItem={tabOptions.find((option) => option.value === field.value)}
            placeholder={t('pages.configuration.followups.chatbot.general-form.dashboard-tab-placeholder')}
          />
          {errors.options?.requestHumanReview?.subject && (
            <span className="c-text-sm c-text-danger-600">
              {t('pages.configuration.followups.chatbot.general-form.dashboard-tab-required-error')}
            </span>
          )}
        </div>
      )}
    />
  )
}
